import React from 'react';

import MPubCard, { MPubCardSkeleton } from './mPubCard.js';
import AjaxFunctions from '../ajaxFunctions.js';
import { CardModal } from './cardModal.jsx';
import * as SharedConstants from '../../../../shared/sharedConstants';

import moment from 'moment';
import { connect } from 'react-redux/dist/react-redux.min.js';
import ReduxStore from '../redux/reduxStore.jsx';
import {
    Button,
    Typography,
} from '@material-ui/core';

const LIMIT = 10;
const START_DATE = 0;
const END_DATE = 14000000;

class MPubList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            sortBy: 'mostLiked',
            recent: [], recentOffset: 0,
            mostUsed: [], mostUsedOffset: 0,
            mostLiked: [], mostLikedOffset: 0,
        };
    }

    componentDidMount() {
        Promise.all([
           this.getRecent(),
           this.getMostUsed(),
           this.getMostLiked(),
           this.getDecks(),
        ])
           .then(() => this.setState({ loading: false }));
    }

    increaseOffset() {
        this.setState(state => {
            const sortByOffset = state[`${state.sortBy}Offset`];
            return { [`${state.sortBy}Offset`]: sortByOffset + LIMIT };
        }, () => {
            if (this.state.sortBy == 'recent') {
                this.getRecent();
            } else if (this.state.sortBy == 'mostUsed') {
                this.getMostUsed();
            } else if (this.state.sortBy == 'mostLiked') {
                this.getMostLiked();
            }
        });
    }

    getRecent() {
        const { recent, recentOffset } = this.state;
        return AjaxFunctions.getLatestMPubs(LIMIT, recentOffset).then(data => {
            const r = [...recent, ...data];
            const recentFull = data.length == LIMIT;
            this.setState({ recent: r, recentFull });
        });
    }

    getMostUsed() {
        const { mostUsed, mostUsedOffset } = this.state;
        return Promise.all([
            AjaxFunctions.getMostUsefulEvidence(LIMIT, mostUsedOffset, START_DATE, END_DATE),
            AjaxFunctions.getMostUsefulConjecture(LIMIT, mostUsedOffset, START_DATE, END_DATE)
        ]).then(data => {
            const mu = [...mostUsed, ...data[0], ...data[1]].sort((a, b) => b.count - a.count);
            const mostUsedFull = data[0].length == LIMIT || data[1].length == LIMIT;
            this.setState({ mostUsed: mu, mostUsedFull });
        });
    }

    getMostLiked() {
        const { mostLiked, mostLikedOffset } = this.state;
        return Promise.all([
            AjaxFunctions.getMostComplimentedEvidence(LIMIT, mostLikedOffset, START_DATE, END_DATE),
            AjaxFunctions.getMostComplimentedConjecture(LIMIT, mostLikedOffset, START_DATE, END_DATE),
        ]).then(data => {
            const ml = [...mostLiked, ...data[0], ...data[1]].sort((a, b) => b.count - a.count);
            const mostLikedFull = data[0].length == LIMIT || data[1].length == LIMIT;
            this.setState({ mostLiked: ml, mostLikedFull });
        });
    }

    async getDecks(){
       let deckList = await AjaxFunctions.getDecks();
       ReduxStore.store.dispatch(ReduxStore.DeckFunctions.setDeckList(deckList));
    }

    buttonProps(type) {
        return {
            className: 'material-button',
            color: 'primary',
            variant: type == this.state.sortBy
                ? 'contained'
                : 'outlined',
        };
    }

    render() {
        const {
            loading,
            sortBy,
            recent,
            mostUsed,
            mostLiked,
        } = this.state;
        const { cards, cardLinkFunction } = this.props;
        const sorted = cards || this.state[sortBy];
        return (
            <div className='homepage-list'>
                <div className={`list-options ${cards ? 'hidden' : ''}`}>
                    <Typography variant='h6'>SORT BY</Typography>
                    <div className='option-buttons'>
                        {mostLiked.length > 0 &&
                            <Button
                                {...this.buttonProps('mostLiked')}
                                onClick={() => this.setState({ sortBy: 'mostLiked'})}>
                                    Most Liked
                            </Button>
                        }
                        {recent.length > 0 &&
                            <Button
                                {...this.buttonProps('recent')}
                                onClick={() => this.setState({ sortBy: 'recent'})}
                            >
                                Recent
                            </Button>
                        }
                        {mostUsed.length > 0 &&
                            <Button
                                {...this.buttonProps('mostUsed')}
                                onClick={() => this.setState({ sortBy: 'mostUsed'})}
                            >
                                Most Used
                            </Button>
                        }
                    </div>
                </div>
                <div className='list-items'>
                    {loading ? (
                        <>
                            <MPubCardSkeleton />
                            <MPubCardSkeleton />
                            <MPubCardSkeleton />
                        </>
                    ) : (
                        <>
                            {sorted.map(card =>
                                <MPubCard key={`${sortBy}-${card.id}`} card={card} cardLinkFunction={cardLinkFunction} />
                            )}
                            {!cards && this.state[`${sortBy}Full`] && sorted.length > 0 &&
                                <Button
                                    className='material-button'
                                    variant='outlined'
                                    size='large'
                                    onClick={() => this.increaseOffset()}
                                >
                                    Load More
                                </Button>
                            }
                        </>
                    )}
                </div>
                <CardModal returnUrl='/' />
            </div>
        );
    }
}

// Redux stuff for CardModal
const mapListViewStateToProps = (state) => {
    return {
        curEvidenceCard: state.EvidenceCardReducer.curCard,
        curGreyspaceCard: state.GreySpaceCardReducer.curCard
    }
 };

 const mapListViewDispatchToProps = (dispatch) => {
    return {
       cardLinkFunction: (cardData) => {
          if(cardData.cardType === SharedConstants.CardType.Evidence) {
             dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
          }
          else if(cardData.cardType === SharedConstants.CardType.Reasoning)
             dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));
       },
       resetCardData: (cardType) => {
          if(cardType === SharedConstants.CardType.Evidence) {
             dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(new SharedModels.EvidenceCard({})));
          }
          else if(cardType === SharedConstants.CardType.Reasoning)
             dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(new SharedModels.GreySpaceCard({})));
       },
    }
 };

 export default connect(
    mapListViewStateToProps,
    mapListViewDispatchToProps
 )(MPubList);
